module.exports = {"130473001":"城南街道","130473100":"高臾镇","130473101":"西光禄镇","130473102":"林坛镇","130473103":"马头镇","130473200":"辛庄营乡","130473201":"花官营乡","130473202":"台城乡","130473203":"南城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130473.json
// module id = 215
// module chunks = 0